import type { SVGProps } from 'react';

const SvgProfileMerging = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="profile-merging">
      <path d="M28.57 24.91h-1v1.5h1a2.76 2.76 0 0 0 2.76-2.75V3.52A2.76 2.76 0 0 0 28.58.77H9.33a2.76 2.76 0 0 0-2.75 2.75v.57h1.5v-.57a1.25 1.25 0 0 1 1.25-1.25h19.25a1.26 1.26 0 0 1 1.25 1.25v20.14a1.26 1.26 0 0 1-1.26 1.25" />
      <path d="M.55 28.41a2.76 2.76 0 0 0 2.75 2.75h20a2.77 2.77 0 0 0 2.8-2.76V8.27a2.75 2.75 0 0 0-2.75-2.75H3.3A2.75 2.75 0 0 0 .55 8.27Zm8.72-5.56A1 1 0 0 1 9.5 22a1 1 0 0 1 .77-.36h6.11a1 1 0 0 1 .77.36 1 1 0 0 1 .23.82l-1.11 6.81h-5.84ZM2.05 8.27A1.25 1.25 0 0 1 3.3 7h20.05a1.26 1.26 0 0 1 1.25 1.27V28.4a1.27 1.27 0 0 1-1.26 1.26h-5.55l1.07-6.57a2.51 2.51 0 0 0-2.48-2.92h-6.11a2.49 2.49 0 0 0-1.91.88 2.52 2.52 0 0 0-.57 2l1.12 6.57H3.3a1.25 1.25 0 0 1-1.25-1.25Z" />
      <path d="M13.4 18.57a4.33 4.33 0 1 0-4.33-4.33 4.34 4.34 0 0 0 4.33 4.33m0-7.16a2.83 2.83 0 1 1-2.83 2.83 2.84 2.84 0 0 1 2.83-2.83" />
    </g>
  </svg>
);

export default SvgProfileMerging;
